var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / SI") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 13.3333333,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.4%",
    y: "-22.5%",
    width: "110.7%",
    height: "145.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-SI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33333333,4.66666667 C8.30367251,4.66666667 9.24397786,5.33333333 9.24397786,5.33333333 L9.24397786,6.66666667 L28,6.66666667 L28,13.3333333 L0,13.3333333 L0,6.66666667 L5.33333333,6.66666667 L5.33333333,5.33333333 C5.33333333,5.33333333 6.36299415,4.66666667 7.33333333,4.66666667 Z M7.33333333,6.66666667 C6.59695367,6.66666667 6,7.26362033 6,8 C6,8.73637967 6.59695367,9.33333333 7.33333333,9.33333333 C8.069713,9.33333333 8.66666667,8.73637967 8.66666667,8 C8.66666667,7.26362033 8.069713,6.66666667 7.33333333,6.66666667 Z",
    id: "Combined-Shape",
    fill: "#0C47B7",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#E53B35",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSi);
export default __webpack_public_path__ + "static/media/SI.d28b53a01b089c6f771c26f1b6aa2557.svg";
export { ForwardRef as ReactComponent };